import { RelatedPages } from "@launerlondon/shop-components";
import { useMetaTags } from "@launerlondon/shop-hooks";
import { useState } from "react";
import { ParallaxBanner } from "react-scroll-parallax";
import NewsletterForm from "../components/NewsletterForm";
import { Link } from "react-router";
import { routes } from "@launerlondon/shop-router";

const bannerUrl = "/images/pages/newsletter-hero.webp";

export default function Newsletter() {
	useMetaTags({
		title: "Sign-up to our newsletter",
		description:
			"With our compliments. A £100 gift when you sign-up to the Launer VIP newsletter.",
		image: bannerUrl,
	});
	const [subscribed, setSubsribed] = useState(false);
	return (
		<div>
			<ParallaxBanner
				layers={[
					{
						speed: -20,
						expanded: false,
						children: (
							<div
								className="ln-banner-image"
								style={{ backgroundImage: `url(${bannerUrl}` }}
							/>
						),
					},
				]}
				className="ln-banner"
			/>
			<div className="">
				<header className="ln-intro-grid container">
					<div>
						<h1 className="font-display">Launer Newsletter</h1>
					</div>
					<p>
						Be the first to know the latest from Launer; news,
						styles and limited edition pieces. Sign up for our VIP
						newsletter today for exclusive communications!
					</p>
				</header>

				<div className="container grid max-w-[930px] gap-20 text-center">
					<div className="space-y-2">
						<h3 className="ln-subtitle">WITH OUR COMPLIMENTS</h3>
						<h4 className="font-medium">
							A £100 gift when you sign-up to the Launer VIP
							newsletter.
						</h4>
						<p>
							Experience an expertly crafted Launer bag with its
							renowned heritage and unparalleled craftsmanship
							with our introductory gift. When you order a handbag
							until the end of July, Launer will pledge a £100
							e-card towards your chosen style, available
							worldwide. To be eligible, just sign up to our VIP
							newsletter (which ensures you are the first to know
							about new arrivals, limited editions and other
							exclusive benefits), where you will receive a code.
							It’s that simple.
						</p>
					</div>
					<div className="space-y-8">
						<div className="rounded bg-neutral-100 pb-8 pt-12">
							{subscribed ? (
								<p>
									Thank you for signing-up to receive the
									Launer newsletter.
									<br />
									<b>
										We’ve sent the £100 code to your email
										address.
									</b>
								</p>
							) : (
								<NewsletterForm
									className="-mb-5"
									onSuccess={() => setSubsribed(true)}
								/>
							)}
						</div>
						<Link className="text-sm underline" to={routes.terms}>
							Terms and Conditions Apply
						</Link>
					</div>
				</div>
			</div>
			<RelatedPages
				pages={[
					{
						title: "Royal Warrant",
						link: "/royal-warrant",
						image: "/images/assets/related-royalwarrant.webp",
					},
					{
						title: "Heritage",
						link: "/heritage-story",
						image: "/images/assets/related-heritage.webp",
					},
					{
						title: "Sustainability",
						link: "/sustainability",
						image: "/images/assets/related-responsibility.webp",
					},
				]}
			/>
		</div>
	);
}
